// src/features/executive/sales/drill/TopProceduresDrill.tsx
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useTopProcedures } from '../hooks/use-top-procedures'
import DrillTable from 'features/executive/components/DrillTable/DrillTable'
import type { ExecutiveState } from 'app/slice/executive.slice'
import { formatCurrency } from 'utils/executive.utils'
import { useRegisterDrillExport } from 'features/executive/components/DrillDrawer/DrillExportContext'

const DRILL_LIMIT = 50

export default function TopProceduresDrill() {
  const { t } = useTranslation()
  const stack = useSelector((s: { executive: ExecutiveState }) => s.executive.drillStack)
  const top = stack[stack.length - 1]
  // Drill = the full list behind a card/slice, so lift the card's top-10 cap.
  const { data, loading, error, refetch } = useTopProcedures(top?.scopedFilters, DRILL_LIMIT)

  const widgetTitle = top?.label ?? t('EXECUTIVE.SALES.TOP_PROCEDURES.TITLE')
  useRegisterDrillExport(
    data ? { drillId: 'top-procedures', data } : null,
    'sales.top-procedures',
    widgetTitle
  )

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {top?.label ?? t('EXECUTIVE.SALES.TOP_PROCEDURES.TITLE')}
      </Typography>
      <DrillTable
        rows={data?.items ?? []}
        columns={[
          { key: 'rank', label: t('EXECUTIVE.SALES.COLUMN.RANK'), render: (_r, idx) => idx + 1 },
          { key: 'name', label: t('EXECUTIVE.SALES.COLUMN.NAME'), render: (r) => r.procedureName },
          { key: 'cases', label: t('EXECUTIVE.SALES.COLUMN.CASES'), align: 'right', render: (r) => r.caseCount },
          { key: 'revenue', label: t('EXECUTIVE.SALES.COLUMN.REVENUE'), align: 'right', render: (r) => formatCurrency(r.revenue) },
          { key: 'avg', label: t('EXECUTIVE.SALES.COLUMN.AVG_PER_CASE'), align: 'right', render: (r) => formatCurrency(r.avgPerCase) },
        ]}
        loading={loading}
        error={error}
        onRetry={refetch}
      />
    </Box>
  )
}
